import * as moment from "moment";

export const formatDateWithoutZone = (date: Date | moment.Moment) => {
    return moment(date).format("YYYY-MM-DDTHH:mm:ss");
};

export const displayTimeRange = (start: moment.Moment, end: moment.Moment, delim: string) => {
    // start and end dates are on the same day
    const noon = moment(start).startOf("day").add(12, "hours");
    const bothAreBeforeOrAfterNoon = (start.isBefore(noon) && end.isBefore(noon))
        || (start.isSameOrAfter(noon) && end.isSameOrAfter(noon));
    return bothAreBeforeOrAfterNoon
        ? `${start.format("h:mm")}${delim}${end.format("h:mma")}`
        : `${start.format("h:mma")}${delim}${end.format("h:mma")}`;
};

export const displayTimeDuration = (minutes: number, shortVersion: boolean): string => {
    const unitM = shortVersion ? "m" : " minute";
    const unitH = shortVersion ? "h" : " hour";

    if (minutes < 60)
        return `${minutes}${unitM + (minutes > 1 && !shortVersion ? "s" : "")}`;
    else if (minutes < 60 * 24) {
        const hours = Math.floor(minutes / 60);
        const minsLeft = minutes % 60;
        const minsDisplay = minsLeft === 0 ? "" : displayTimeDuration(minsLeft, shortVersion);
        return `${hours}${unitH + (hours > 1 && !shortVersion ? "s" : "")} ${minsDisplay}`;
    }
    else
        return minutes.toString();
};



// WEBPACK FOOTER //
// ./src/utils/DateHelper.ts